'use client'

import { Loader2Icon } from 'lucide-react'
import { useFormStatus } from 'react-dom'
import { Button } from '@/components/ui/button'

type SubmitButtonProps = React.ComponentProps<typeof Button> & { pending?: boolean }

export function SubmitButton({ children, pending, disabled, ...props }: SubmitButtonProps) {
	const status = useFormStatus()
	const isPending = pending ?? status.pending
	return (
		<Button type="submit" disabled={disabled || isPending} {...props}>
			{isPending && <Loader2Icon className="animate-spin" />}
			{children}
		</Button>
	)
}
